import React from 'react';
import { connect } from 'react-redux';

import ListPage from '@/src/shared/components/ListPage';
import withMembershipAccessWrap, {
  mapStateToProps,
} from '@/src/shared/components/MembershipPageWrap';
import { COMPLIANCE_ACCESS } from '@/src/shared/constants';
import useListSearch from '@/src/shared/hooks/useListSearch';

const AccidentPreventionCompliance = () => {
  const [loading, results] = useListSearch({
    pubCode: 26,
    yearsBack: 5,
  });

  return (
    <ListPage
      title="Accident Prevention Compliance for Insurers"
      heroContent={<p>Documents from the last 5 years</p>}
      results={results}
      loading={loading}
    />
  );
};

export default connect(mapStateToProps)(
  withMembershipAccessWrap(AccidentPreventionCompliance, COMPLIANCE_ACCESS.COMPLIANCE_RESOURCES)
);
